import { Box, Typography } from "@mui/material";

// 玄関（/）の下に並べる「できること」の段。題・説明・（子に）扉と注意書き。
// 夜の参道パレット。ここは増やしていく前提で、題と文だけを差し替えれば一段増やせる。

const SERIF = '"Hiragino Mincho ProN", "Yu Mincho", serif';
const WASHI = "#ece5d4";
const WASHI_DIM = "rgba(222,215,198,0.6)";
const GOLD = "#d4b46e";

export default function Category({ title, body, children, testId }) {
  return (
    <Box data-testid={testId} sx={{ maxWidth: 480, mx: "auto", px: 2.5, py: { xs: 6, sm: 8 }, textAlign: "center" }}>
      <Box
        sx={{
          width: 32,
          height: "1px",
          mx: "auto",
          mb: 4,
          background: `linear-gradient(90deg, transparent, ${GOLD}, transparent)`,
        }}
      />
      <Typography
        component="h2"
        sx={{
          fontFamily: SERIF,
          fontWeight: 600,
          fontSize: { xs: "1.15rem", sm: "1.3rem" },
          letterSpacing: 4,
          textIndent: 4,
          lineHeight: 1.9,
          color: WASHI,
          mb: 2.5,
        }}
      >
        {title}
      </Typography>
      {body && (
        <Typography
          sx={{
            fontFamily: SERIF,
            fontSize: { xs: "0.88rem", sm: "0.95rem" },
            letterSpacing: 1.2,
            lineHeight: 2.2,
            whiteSpace: "pre-line",
            color: WASHI_DIM,
            mb: 4,
          }}
        >
          {body}
        </Typography>
      )}
      {children}
    </Box>
  );
}
